<template>
  <div
    v-if="eventIsVisible"
    class="fc-event-main-frame d-flex"
    @click="onEventClicked"
    @dblclick="onEventDoubleClicked"
  >
    <div class="fc-event-time">
      <span
        v-if="dotIsVisible"
        class="fc-daygrid-event-dot"
      />
      <span>{{ eventTime }}</span>
    </div>
    <div class="fc-event-title-container">
      <div class="fc-event-title fc-sticky">
        <span>{{ eventTitle }}</span>
      </div>
      <div
        v-if="eventIsDone"
        class="fc-event-done-checkmark pr-1 pl-2"
      >
        <v-icon
          dark
          small
        >
          mdi-check-circle
        </v-icon>
      </div>
    </div>
    <div
      v-if="eventIsFromLinkedCalendar"
      class="gcal-icon"
    >
      <v-badge
        color="#4285F4"
        :icon="calendarServiceIcon"
        overlap
        x-small
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarEvent',

  props: {
    calendarEvent: {
      type: Object,
      required: true,
    },
  },

  computed: {
    calendarServiceIcon () {
      const service = this.calendarEvent.event.extendedProps.service

      if (service === 'GCal') return 'mdi-google'
      return 'mdi-calendar-question'
    },

    dotIsVisible () {
      return ['list-item', 'auto', undefined].includes(this.calendarEvent.event.display)
    },

    eventIsDone () {
      return this.calendarEvent.event.extendedProps.isDone
    },

    eventIsFromLinkedCalendar () {
      return !!this.calendarEvent.event.extendedProps.service
    },

    eventIsVisible () {
      return this.calendarEvent.event.display !== 'none'
    },

    eventTime () {
      return this.calendarEvent.timeText
    },

    eventTitle () {
      return this.calendarEvent.event.title
    },
  },

  methods: {
    onEventClicked () {
      this.$emit('click', this.calendarEvent.event)
    },

    onEventDoubleClicked () {
      this.$emit('dblclick', this.calendarEvent.event)
    },
  },
}
</script>
